__turbopack_context__.v({
  "link": "navLink-module-scss-module__07VjOa__link",
  "visually-hidden": "navLink-module-scss-module__07VjOa__visually-hidden",
});
